import React from 'react';

class TextAreaCharacterLimit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingCharacters: props.characterLimit - props.value.length
    };
    this.onChange = this.onChange.bind(this);
    this.checkRemainingCharacters = this.checkRemainingCharacters.bind(this);
  }

  checkRemainingCharacters(newValue) {
    const remainingCharacters = this.props.characterLimit - newValue.length;
    return {
      hasSurpassed: remainingCharacters < 0,
      remainingCharacters
    };
  }

  onChange($evt) {
    const remainingCharactersResult = this.checkRemainingCharacters($evt.target.value);
    if (this.props.preventChangeOnLimit && remainingCharactersResult.hasSurpassed)
      return false;

    this.props.onChange($evt.target.value);
    this.setState({ remainingCharacters: remainingCharactersResult.remainingCharacters });
  }

  render() {
    return (
      <div className={this.props.containerClassname}>
        <textarea
          rows={this.props.rows}
          onChange={this.onChange}
          value={this.props.value}
          disabled={this.props.disabled || false}
          placeholder={this.props.placeholderText}
          className={this.props.textareaClassname}
        />
        <div className="fs-emeric-light u-text-right u-margin-bottom-none">Remaining characters: {this.state.remainingCharacters}</div>
      </div>
    );
  }
}

export default TextAreaCharacterLimit;


// WEBPACK FOOTER //
// ./src/parts/TextAreaCharacterLimit.js